export const defaultCharWidth = 9;
export const defaultContainerWidth = 400;
export const defaultMarginWidth = 50;
